import * as Util from '../common/util';
import Env from '../common/env';
import Dom from './mdom.js';

function _addEvent(target, type, callback) {
    if (target.addEventListener) {
        target.addEventListener(type, callback, false);
    } else if (target.attachEvent) {
        target.attachEvent("on" + type, callback);
    } else {
        target["on" + type] = callback;
    }
}

function isBlockForIosIFrame(evt) {
    try{
        if(Dom.window.hackIFrameEvent 
            && Dom.window.hackIFrameEvent === true
            && Dom.window != window 
            && /(iPhone|iPad|iPod|iOS)/i.test(Dom.window.navigator.userAgent)
            && evt.changedTouches[0].clientY - Dom.document.body.scrollTop > Dom.window.innerHeight - Dom.window.document.getElementById("tab_box").clientHeight)
        { 
            Dom.window.dealIosIFrameClickBug && Dom.window.dealIosIFrameClickBug(evt);
            return true;
        } 
    }catch(e){
    }    
    return false;
}

var touchTimeout;
var isWkWebview;
function clearAll() {
    clearTimeout(touchTimeout);
    touchTimeout = null;
}
if(!Env.isCSR) {
    isWkWebview = window.__wxjs_is_wkwebview === 'yes' || window.__wxjs_is_wkwebview
                        || Dom.window.__wxjs_is_wkwebview === 'yes' || Dom.window.__wxjs_is_wkwebview;
    // 修复快速滑动后停止后容易跳转到帖子的体验问题
    window.addEventListener('scroll', clearAll);
}else{
    isWkWebview = false;
}

// 过渡方案，不建议使用，请使用上面的方法
// target       : Dom对象, 绑定事件父层元素
// clickEventObj: 函数或对象
/*
    function类型时, 仅在touchend时触发, clickedDom 可以是:
        <div op="guideJump">XXXX</div>
        <span>点我</span>
    function(evt, clickedDom){  }

    obj时:
    {
        touchstart: function(evt){ //可选
        
        },
        touchmove: function(evt){ //可选
        
        },
        touchend:  function(evt){
        
        },
        useTouch : true/false   //则不论是不是wkwebview, 都用touch事件, 默认为 false
    }
 */
function fastClick(target, clickEvtObj) {
    var that     = this;
    var disY     = 0,
        disX     = 0;
    var prePageY = 0,
        pageY    = 0;
    var prePageX = 0,
        pageX    = 0;

    if (!target) { return; }
    var handler  = clickEvtObj instanceof Function ? clickEvtObj : false;
    var useTouch = clickEvtObj.useTouch && clickEvtObj.useTouch === true;

    function stopPopEvents(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    
    // pc 和 android wkwebview 直接用click, 强制使用touch的除外
    // if((!useTouch && isWkWebview) || Util.clientInfo.isWPcWechat){
    if((!useTouch && isWkWebview) || (!Util.clientInfo.isIOS && !Util.clientInfo.isAndroid)){
        addEvent(target, "click", function(evt) {
            var elName = (evt.target || evt.srcElement);
            if(isBlockForIosIFrame(evt) === true){
                return;
            }
            /**
             *  使用setTimeout，stopPopEvents
             */
            if(clickEvtObj.isCurrentlyCbk){
                stopPopEvents(evt);
                handler ? handler.call(that, evt, elName)
                    : clickEvtObj && clickEvtObj.touchend && clickEvtObj.touchend.call(that, evt, elName);
            }else{
                setTimeout(function() {
                    stopPopEvents(evt);
                    handler ? handler.call(that, evt, elName)
                        : clickEvtObj && clickEvtObj.touchend && clickEvtObj.touchend.call(that, evt, elName);
                }, 0);
            }

        });
        return;
    }
    addEvent(target, "touchstart", function (evt) {
        var elName   = (evt.target || evt.srcElement);
            disY     = 0;
            disX     = 0;
            prePageY = evt.touches[0].pageY;
            prePageX = evt.touches[0].pageX;
        clickEvtObj && clickEvtObj.touchstart && clickEvtObj.touchstart.call(that, evt, elName);
    });
    addEvent(target, "touchmove", function (evt) {
        var elName = (evt.target || evt.srcElement);
        pageY      = evt.touches[0].pageY;
        pageX      = evt.touches[0].pageX;
        disY      += Math.abs(pageY - prePageY);
        disX      += Math.abs(pageX - prePageX);
        prePageY   = pageY;
        prePageX   = pageX;
        clickEvtObj && clickEvtObj.touchmove && clickEvtObj.touchmove.call(that, evt, elName);
    });
    addEvent(target, "touchend", function (evt) {
        if (Math.abs(disY) == 0 && Math.abs(disX) == 0) {
            var elName = (evt.target || evt.srcElement);
            clearAll();
            // 不能在此时去掉event的冒泡，不然click事件有可能会失效
            // stopPopEvents(evt);

            touchTimeout = setTimeout(function () {
                stopPopEvents(evt);
                if(isBlockForIosIFrame(evt) === true){
                    return;
                }
                handler  ? handler.call(that, evt, elName) 
                         : clickEvtObj.touchend && clickEvtObj.touchend.call(that, evt, elName);

            }, isWkWebview ? 0 : 10);
        }
        evt.stopPropagation();
    });
}

const exported = {
    on      : _addEvent,
    tap     : fastClick,
    click   : fastClick,
    addEvent: _addEvent
} 
export default exported; 
export const { on, tap, click, addEvent} = exported;
